import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { useAuth } from '../Context/Context'

import {
  setFile,
  deleteFile,
  setFilePDF
} from '../Firebase/Redux/Features/Storage/storageSlice'

const useDatabase = ({
  consulta,
  file,
  name,
  folder,
  metadata,
  url,
  urlFile,
  filesJSON,
  urlsDelete
}) => {
  const dispatch = useDispatch()
  const history = useNavigate()
  const { recargar } = useAuth()
  const [result, setResult] = useState(false)

  const agregar = async () => {
    let res = await dispatch(setFile({ file, name, folder }))

    if (
      res.payload.status === 'failed' ||
      res.meta.requestStatus === 'failed'
    ) {
      return Swal.fire({
        title: 'Error',
        text: 'El campo no logro ser agregado',
        confirmButtonColor: '#2DCD22',
        confirmButtonText: 'Continuar',
        icon: 'error'
      }).then(() => {
        history(url)
      })
    }

    setResult({ url: res.payload, action: consulta })
  }

  const agregarPdf = async () => {
    let res = await dispatch(setFilePDF({ file, name, folder, metadata }))

    if (
      res.payload.status === 'failed' ||
      res.meta.requestStatus === 'failed'
    ) {
      return Swal.fire({
        title: 'Error',
        text: 'El campo no logro ser agregado',
        confirmButtonColor: '#2DCD22',
        confirmButtonText: 'Continuar',
        icon: 'error'
      }).then(() => {
        history(url)
      })
    }

    setResult({ url: res.payload, action: consulta })
  }

  const eliminar = async () => {
    Swal.fire({
      icon: 'question',
      title: '¿Esta seguro que desea eliminar el campo?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Si',
      denyButtonText: `No`
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        let res = await dispatch(deleteFile({ urlFile }))

        if (
          res.payload.status === 'failed' ||
          res.meta.requestStatus === 'failed' ||
          !res.payload
        ) {
          return Swal.fire({
            title: 'Error',
            text: 'El campo no logro ser eliminado',
            confirmButtonColor: '#2DCD22',
            confirmButtonText: 'Continuar',
            icon: 'error'
          }).then(recargar)
        }

        setResult({ success: res.payload, action: consulta })
      } else if (result.isDenied) {
        Swal.fire('Eliminación cancelada', 'El campo quedo intacto', 'succes')
      }
    })
  }

  // Para reemplazos: el usuario ya confirmó al subir el archivo nuevo
  const eliminarSinConfirmar = async () => {
    let res = await dispatch(deleteFile({ urlFile }))
    setResult({ success: res.payload === true, action: consulta })
  }

  const actualizar = async () => {
    Swal.fire({
      icon: 'question',
      title: '¿Esta seguro que desea modificar el campo?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Si',
      denyButtonText: `No`
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        let res = await dispatch(deleteFile({ urlFile }))

        if (
          res.payload.status === 'failed' ||
          res.meta.requestStatus === 'failed' ||
          !res.payload
        ) {
          return Swal.fire(
            'Error!',
            'No se pudo modificar el campo',
            'error'
          ).then(recargar)
        }

        setResult({ success: res.payload, action: consulta })
      } else if (result.isDenied) {
        Swal.fire('Modificación cancelada', 'El campo quedo intacto', 'succes')
      }
    })
  }

  // este es una funcion solo para los cursos
  const agregarRecursivoCursos = async (
    index = 0,
    resFinal = {},
    error = false,
    indexCarrusel = 0,
    carruselArray = []
  ) => {
    const { files, filesCarrusel } = filesJSON
    let copiaIndex = index + 1
    let copiaResFinal = { ...resFinal }
    let copiaError = error
    let copiaIndexCarrusel = indexCarrusel
    let copiaCarruselArray = carruselArray

    const agregra = async (file, tipo) => {
      let nombreFinal = name + '_' + tipo
      let carpetaFinal = folder + name + '/'

      if (tipo === 'carrusel') {
        nombreFinal = nombreFinal + '_' + indexCarrusel
      }

      let res = await dispatch(
        setFile({ file, name: nombreFinal, folder: carpetaFinal })
      )

      if (
        res.payload.status === 'failed' ||
        res.meta.requestStatus === 'failed'
      ) {
        copiaError = true
      }

      if (tipo === 'extarna') {
        copiaResFinal.imagen_externa = res.payload
        agregarRecursivoCursos(copiaIndex, copiaResFinal, copiaError)
      } else if (tipo === 'individual') {
        copiaResFinal.imagen_indvidual = res.payload
        agregarRecursivoCursos(copiaIndex, copiaResFinal, copiaError)
      } else if (tipo === 'interna') {
        copiaResFinal.imagen_interna = res.payload
        agregarRecursivoCursos(copiaIndex, copiaResFinal, copiaError)
      } else if (tipo === 'carrusel') {
        copiaIndexCarrusel = copiaIndexCarrusel + 1
        copiaCarruselArray.push(res.payload)
        copiaResFinal.carrusel_imagenes = copiaCarruselArray

        if (copiaIndexCarrusel <= filesCarrusel.length - 1) {
          agregarRecursivoCursos(
            copiaIndex,
            copiaResFinal,
            copiaError,
            copiaIndexCarrusel,
            copiaCarruselArray
          )
        } else {
          setResult({ data: copiaResFinal, success: true, action: consulta })
        }
      }
    }

    if (index === 0) {
      if (files.imagen_externa) {
        agregra(files.imagen_externa, 'extarna')
      } else {
        agregarRecursivoCursos(
          copiaIndex,
          copiaResFinal,
          copiaError,
          copiaIndexCarrusel,
          copiaCarruselArray
        )
      }
    } else if (index === 1) {
      if (files.imagen_indvidual) {
        agregra(files.imagen_indvidual, 'individual')
      } else {
        agregarRecursivoCursos(
          copiaIndex,
          copiaResFinal,
          copiaError,
          copiaIndexCarrusel,
          copiaCarruselArray
        )
      }
    } else if (index === 2) {
      if (files.imagen_interna) {
        agregra(files.imagen_interna, 'interna')
      } else {
        agregarRecursivoCursos(
          copiaIndex,
          copiaResFinal,
          copiaError,
          copiaIndexCarrusel,
          copiaCarruselArray
        )
      }
    } else {
      if (filesCarrusel) {
        agregra(filesCarrusel[indexCarrusel], 'carrusel')
      } else {
        copiaIndexCarrusel = copiaIndexCarrusel + 1
        agregarRecursivoCursos(
          copiaIndex,
          copiaResFinal,
          copiaError,
          copiaIndexCarrusel,
          copiaCarruselArray
        )
      }
    }
  }

  // esta funcion es para todos los que sean un array de archivos
  const agregarRecursivo = async (
    index = 0,
    error = false,
    carruselArray = []
  ) => {
    const { files } = filesJSON
    let file = files[index]
    let copiaError = error
    let copiaCarruselArray = [...carruselArray]

    let nombreFinal = name + '_' + index
    let carpetaFinal = folder + name + '/'

    let res = await dispatch(
      setFile({ file, name: nombreFinal, folder: carpetaFinal })
    )

    if (
      res.payload.status === 'failed' ||
      res.meta.requestStatus === 'failed'
    ) {
      copiaError = true
    }

    copiaCarruselArray.push(res.payload)

    if (index < files.length - 1) {
      let copiaIndex = index + 1

      agregarRecursivo(copiaIndex, copiaError, copiaCarruselArray)
    } else {
      setResult({ data: copiaCarruselArray, success: true, action: consulta })
    }
  }

  const eliminarRecursivo = async (index = 0, error = false) => {
    const copiaIndex = index + 1
    let copiaError = error

    let res = await dispatch(deleteFile({ urlFile: urlsDelete[index] }))

    if (
      res.payload.status === 'failed' ||
      res.meta.requestStatus === 'failed' ||
      !res.payload
    ) {
      copiaError = true
    }

    if (index < urlsDelete.length - 1) {
      eliminarRecursivo(copiaIndex, copiaError)
    } else {
      setResult({ success: true, action: consulta })
    }
  }

  useEffect(() => {
    switch (consulta) {
      case 'agregar':
        agregar()
        break
      case 'eliminar':
        eliminar()
        break
      case 'eliminarSinConfirmar':
        eliminarSinConfirmar()
        break
      case 'eliminarRecursivo':
      case 'eliminarRecursivoActualizar':
        eliminarRecursivo()
        break
      case 'actualizar':
        actualizar()
        break
      case 'agregarActualizado':
        agregar()
        break
      case 'agregarRecursivoCursos':
        agregarRecursivoCursos()
        break
      case 'agregarRecursivo':
        agregarRecursivo()
        break
      case 'agregarPdf':
        agregarPdf()
        break
      default:
        // console.log("indefinido");
        break
    }
  }, [consulta])

  return [result]
}

export default useDatabase
